import { useNavigation } from "@react-navigation/native";
import React, { FC } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { useSelector } from "react-redux";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kRoute } from "src/kRoute";
import { kStyleConst } from "src/kStyle";

const P01_02_ApplicationSent: FC = () => {
  const kNav = useNavigation();
  const dispatch = useAppDispatch();
  const rIsMobile = useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );

  const isSmall = useSelector((state) => state.NavigationReducer.drawerType);

  const navigateToHome = () => {
    dispatch({ type: "APPLICATION_RESET" });
    kNav.navigate(kRoute.P01);
  };

  return (
    <ScrollView
      contentContainerStyle={[styles.container, rIsMobile ? styles.m5 : styles.m10]}
      style={styles.bgBrandLight}
    >
      <View style={isSmall === "slide" ? styles.P01_02_ContentViewSmall : styles.P01_02_ContentView}>
        <Text style={styles.P01_02_TitleText}>Your application has been sent!</Text>
        <Text style={styles.P01_02_BodyText}>
          You will receive a confirmation email after your application has been reviewed.
        </Text>
        <PdButton size="lg" onPress={navigateToHome} style={styles.mt10}>
          <PdButtonLabel>Back to Home</PdButtonLabel>
        </PdButton>
      </View>
    </ScrollView>
  );
};

export const P01_02 = React.memo(P01_02_ApplicationSent);
const styles = StyleSheet.create({
  P01_02_BodyText: {
    ...kFonts.poppinsRegularLight,
    color: kColors.brandDark,
    textAlign: "center",
  },
  P01_02_ContentView: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderRadius: 4 * kStyleConst.kBorderRadius,
    flex: 1,
    justifyContent: "center",
    marginHorizontal: 18 * kStyleConst.kSpacing,
    marginVertical: 10 * kStyleConst.kSpacing,
    padding: 6 * kStyleConst.kSpacing,
  },
  P01_02_ContentViewSmall: {
    PaddingBottom: 32 * kStyleConst.kSpacing,
    PaddingTop: 10 * kStyleConst.kSpacing,
    alignItems: "center",
    backgroundColor: kColors.white,
    flex: 1,
    justifyContent: "center",
    paddingHorizontal: 16 * kStyleConst.kSpacing,
  },
  P01_02_TitleText: {
    ...kFonts.ralewayExtraLargeMedium,
    color: kColors.brandDark,
    marginBottom: 5 * kStyleConst.kSpacing,
    textAlign: "center",
  },
  bgBrandLight: {
    backgroundColor: kColors.brandLight,
  },
  container: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderRadius: 4 * kStyleConst.kBorderRadius,
    flexGrow: 1,
    justifyContent: "center",
    padding: 10 * kStyleConst.kSpacing,
  },
  m10: {
    margin: 10 * kStyleConst.kSpacing,
  },
  m5: {
    margin: 5 * kStyleConst.kSpacing,
  },
  mt10: {
    marginTop: 10 * kStyleConst.kSpacing,
  },
});
